import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiModule } from './types';

const isCalendlyIntegration = (integration: ManagedMcpIntegration) => {
  const code = (integration.code || '').toLowerCase();
  const name = (integration.name || '').toLowerCase();
  const description = (integration.description || '').toLowerCase();
  return code.includes('calendly') || name.includes('calendly') || description.includes('calendly');
};

export const calendlyProviderUiModule: McpProviderUiModule = {
  providerCode: 'calendly',
  matches: (integration: ManagedMcpIntegration) => isCalendlyIntegration(integration),
  getUiConfig: () => ({
    providerCode: 'calendly',
    displayName: 'Calendly',
    supportsDynamicClientRegistration: true,
    requireClientId: false,
    requireClientSecret: false,
    endpointOverrideLabel: 'Calendly MCP Endpoint Override',
    endpointOverridePlaceholder: 'Optional. Default: https://mcp.calendly.com/',
    endpointOverrideHelpText: 'Leave blank for Calendly hosted MCP endpoint.',
    oauthClientIdLabel: 'OAuth Client ID (optional)',
    oauthClientSecretLabel: 'OAuth Client Secret (optional)',
  }),
};
